module.exports = __webpack_public_path__ + "static/media/p108.480b375b.png";